import { CompanyRole } from '../../models/shared/enums/company-role.enum';
import { PhotographerRole } from '../../models/shared/enums/photographer-role.enum';

export type SidenavGroupItem = {
	sidenavType: SidenavTypeEnum;
	groupName: string;
	groupUrlPart: string;
	groupItems: Array<GroupItem>;
};

export type GroupItem = {
	menuLabel: string;
	menuRoute: string;
	icon: string;
	requiredRoles: Array<CompanyRole | PhotographerRole>;
};

export enum SidenavTypeEnum {
	photographer = 1,
	company = 2
}
